// Garen — Judgment: spins his sword, dealing physical damage to the front 2 enemies
// in 3 real bursts spread across the animation.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const PULSE_COUNT = 3;

export const garenJudgment: Ability = {
  id: "garenJudgment",
  displayName: "Judgment",
  description: "Spins rapidly, dealing physical damage to the front 2 enemies 3 times.",
  iconId: "GarenE",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 2)
      .map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, 2);
    const stats = effectiveStats(caster);
    const perPulse = physicalDamage(stats.ad * 0.5 + 30);
    const hits: AbilityHit[] = [];
    for (let pulse = 0; pulse < PULSE_COUNT; pulse++) {
      for (const e of targets) {
        hits.push({ target: e, amount: perPulse, type: "physical", suppressPopup: true, deferredSpin: true });
      }
    }
    return hits;
  },
};
